import { Ref } from '@vue/composition-api';
import { onBeforeUnmount, onMounted } from '@vue/composition-api';
import {
  //  ErrorCode,
  //   WorkFlowError,
  getDimensions
} from '../utils';
import { useWorkFlow } from './useWorkFlow';

/**
 * Composable that handles the resize of the viewport.
 *
 * @internal
 * @param viewportEl
 */
export function useResizeHandler(viewportEl: Ref<HTMLDivElement | null>): void {
  const { emits, dimensions } = useWorkFlow();

  let resizeObserver: ResizeObserver;

  onMounted(() => {
    const rendererNode = viewportEl.value;

    const updateDimensions = () => {
      if (!rendererNode) {
        return;
      }

      const size = getDimensions(rendererNode);

      if (size.width === 0 || size.height === 0) {
        // emits.error(new WorkFlowError(ErrorCode.MISSING_VIEWPORT_DIMENSIONS))
      }

      dimensions.value = {
        width: size.width || 500,
        height: size.height || 500
      };
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    if (rendererNode) {
      resizeObserver = new ResizeObserver(() => updateDimensions());
      resizeObserver.observe(rendererNode);
    }

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateDimensions);

      if (resizeObserver && rendererNode) {
        resizeObserver.unobserve(rendererNode!);
      }
    });
  });
}
